import { MessageBarType } from "office-ui-fabric-react";
import {IRootState} from "../store";

export default abstract class Actions {
    public static readonly SET_SCHOOLS_CAN_ACCESS = "SET_SCHOOLS_CAN_ACCESS";
    
    
    public static readonly SHOW_MESSAGE_BAR = "SHOW_MESSAGE_BAR";
    public static readonly HIDE_MESSAGE_BAR = "HIDE_MESSAGE_BAR";
    
    public static fetchSchoolsCanAccess() {
        return async function (dispatch: Function, getState: Function) {
            const state: IRootState = getState();

            const result = await state.auth.apiService.getSchoolsCanAccess();
            dispatch({ type: Actions.SET_SCHOOLS_CAN_ACCESS, schoolsCanAccess: result.schoolsWithAccessLevels,userIsTenantManager: result.tenantManager })
        }
    }
    
    public static showMessageBar(message: string, messageBarType: MessageBarType, actions?: JSX.Element) {
        return {
            type: Actions.SHOW_MESSAGE_BAR,
            message,
            messageBarType,
            actions,
        };
    }

    public static hideMessageBar() {
        return {
            type: Actions.HIDE_MESSAGE_BAR
        }
    }
}

